const SkillPill = ({ label }) => (
  <span
    style={{
      fontSize: 12,
      fontWeight: 500,
      color: '#2068B2',
      background: 'rgba(32,104,178,.08)',
      border: '1px solid rgba(32,104,178,.12)',
      padding: '4px 10px',
      borderRadius: 6,
      display: 'inline-block',
    }}
  >
    {label}
  </span>
);

export default SkillPill;
